import React, { useEffect } from 'react';
import {
  renderLinkedQuestion,
  getLinkedQuestions,
  QuestionGroupViewPropTypes,
} from '../../utils';
import { RowBuilder as RB } from '../../../neuro-ui';
import NeuroMessage from '../NeuroMessage';
import useNeuroState, {
  builderAnswerChanged,
  builderGroupValidation,
  builderQuestionValidation,
  useDispatch,
} from '../../state';
import { useNeuroMessages } from '../MessageContext';

const RowBuilder = ({ questionGroup, renderQuestion, customProps }) => {
  const messageContext = useNeuroMessages();
  const dispatch = useDispatch();
  const { answers } = useNeuroState();
  const attributes = questionGroup?.attributes || {};
  const groupKey = attributes?.questionGroupKey;
  const showAllMode = attributes?.showAllMode || false;
  const value = answers[groupKey];
  const { value: currentValues = [] } = value || {};
  const builderOptions = questionGroup.questions.find(
    (q) => q.appkey === questionGroup.attributes.questionGroupKey
  );

  const builderLinkedQuestions = (builderOptions.answers || []).map((row) => {
    const messageKey = `${builderOptions.appkey}.${row.key}`;
    return {
      id: row.key,
      label: messageContext.formatIntlMessage({ id: messageKey }),
      questions: getLinkedQuestions(
        questionGroup,
        row.attributes.linkedQuestions || []
      ),
    };
  });

  const rowAdded = ({ rowKey, currentValues }) => {
    const value = [...currentValues, rowKey];
    dispatch(
      builderAnswerChanged({ question: builderOptions, questionGroup, value })
    );
  };
  const rowRemoved = ({ rowKey, currentValues }) => {
    const value = currentValues.filter((v) => v !== rowKey);
    dispatch(
      builderAnswerChanged({
        question: builderOptions,
        questionGroup,
        value,
        hasBeenRemoved: rowKey,
      })
    );
  };
  const linkedQuestionValueChanged = (linkedQuestion) => {
    dispatch(
      builderQuestionValidation({
        linkedQuestion,
        questionGroup,
        shouldDisplay: true,
      })
    );
  };
  const validateBuilder = (value) => {
    dispatch(
      builderGroupValidation({ questionGroup, question: builderOptions, value })
    );
  };
  useEffect(() => {
    validateBuilder(currentValues);
  }, []);

  const onChange = (rowKey, added) =>
    added
      ? rowAdded({ rowKey, currentValues })
      : rowRemoved({ rowKey, currentValues });

  return (
    <div>
      <RB
        {...customProps}
        builderOptions={builderOptions}
        checkboxMode={showAllMode}
        onChange={onChange}
        questionGroup={questionGroup}
        renderGoalLabel={
          <NeuroMessage id={builderOptions.appkey} tagName="span" />
        }
        renderQuestion={(linkedQuestion) =>
          renderLinkedQuestion(
            linkedQuestion,
            linkedQuestionValueChanged,
            renderQuestion
          )
        }
        rows={builderLinkedQuestions}
        values={currentValues}
      />
    </div>
  );
};

RowBuilder.propTypes = QuestionGroupViewPropTypes;

export default RowBuilder;
